
import { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import * as React from 'react';
import Moment from 'moment';
import moment from 'moment';

import { authKey, GET_FINANCIAL_YEAR, GET_WEEK_START_END_DATE, GET_APPROVED_STAKEHOLDERS, GET_MANUAL_PO_LIST, GET_PO_BY_PO_NUMBER, CREATE_MANUAL_SCHEDULE, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN, GET_UNRESTRICTED_INVENTORY, GET_INVENTORY_AVAILABLE_FOR_SCHEDULING } from '../../common/URLs';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { DialogContent, Dialog, DialogActions, Divider } from '@mui/material';
import { PROD } from "../../common/constants";
import { PlantConsumptionPopover } from "./plantCBConsumption/plantConsumptionPopover";
import { Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { SubmitIcon } from "../../common/icons";
import apiClient from "../../axios";

function TransporterScheduleCreation() {

    const navigate = useNavigate();
    const [month, setMonth] = useState();
    const [manualPoList, setManualPoList] = useState();
    const [poNumber, setPoNumber] = useState();
    const [poDetails, setPoDetails] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [getStartEndDate, setGetStartEndDate] = useState([]);
    const [getHolidayList, setGetHolidayList] = useState([]);

    const [urnList, setUrnList] = useState([]);
    const [sourceUrnList, setSourceUrnList] = useState([]);
    const [distinctUrnValues, setDistinctUrnValues] = useState([]);
    const [distinctSourceUrnValues, setDistinctSourceUrnValues] = useState();
    const [stakeholderUrn, setStakeholderUrn] = useState('');
    const [stakeholderType, setStakeholderType] = useState('');

    const [firstPartyUrn, setFirstPartyUrn] = useState('');
    const [firstPartyType, setFirstPartyType] = useState('');

    const [scheduleDetails, setScheduleDetails] = useState();
    const [inventoryLevel, setInventoryLevel] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);


    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [details, setDetails] = useState({
        "weekNumber": "",
        "expectedDeliveryDays": "",
        "scheduleQuantity1": "",
        "scheduleQuantity2": "",
        "scheduleQuantity3": "",
        "scheduleQuantity4": "",
        "scheduleQuantity5": "",
        "scheduleQuantity6": "",
        "scheduleQuantity7": ""
    });

    const [errorMessage, setErrorMessage] = useState({
        "weekNumberError": "",
        "firstPartyTypeError": "",
        "firstPartyUrnError": "",
        "secondPartyTypeError": "",
        "secondPartyUrnError": "",
        "expectedDeliveryDaysError": "",
        "scheduleQuantity1Error": "",
        "scheduleQuantity2Error": "",
        "scheduleQuantity3Error": "",
        "scheduleQuantity4Error": "",
        "scheduleQuantity5Error": "",
        "scheduleQuantity6Error": "",
        "scheduleQuantity7Error": "",
    });


    const handleChange = (e) => {
        const limit = 10
        setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) });

        if (e.target.name === "weekNumber") {
            setErrorMessage({ ...errorMessage, weekNumberError: "" });
        }
        if (e.target.name === "expectedDeliveryDays") {
            setErrorMessage({ ...errorMessage, expectedDeliveryDaysError: "" });
        }
        if (e.target.name === "scheduleQuantity1") {
            setErrorMessage({ ...errorMessage, scheduleQuantity1Error: "" });
        }
        if (e.target.name === "scheduleQuantity2") {
            setErrorMessage({ ...errorMessage, scheduleQuantity2Error: "" });
        }
        if (e.target.name === "scheduleQuantity3") {
            setErrorMessage({ ...errorMessage, scheduleQuantity3Error: "" });
        }
        if (e.target.name === "scheduleQuantity4") {
            setErrorMessage({ ...errorMessage, scheduleQuantity4Error: "" });
        }
        if (e.target.name === "scheduleQuantity5") {
            setErrorMessage({ ...errorMessage, scheduleQuantity5Error: "" });
        }
        if (e.target.name === "scheduleQuantity6") {
            setErrorMessage({ ...errorMessage, scheduleQuantity6Error: "" });
        }
        if (e.target.name === "scheduleQuantity7") {
            setErrorMessage({ ...errorMessage, scheduleQuantity7Error: "" });
        }
    };

    const onPoNumberChange = (e) => {
        setPoNumber(e.target.value);
        getPoDetails(e.target.value);
        setErrorMessage({ ...errorMessage, poNumberError: "" });
        setStakeholderType('');
        setStakeholderUrn('');
        setFirstPartyType('');
        setFirstPartyUrn('');
        setInventoryLevel('');
        setDetails({
            "weekNumber": "",
            "expectedDeliveryDays": "",
            "scheduleQuantity1": "",
            "scheduleQuantity2": "",
            "scheduleQuantity3": "",
            "scheduleQuantity4": "",
            "scheduleQuantity5": "",
            "scheduleQuantity6": "",
            "scheduleQuantity7": ""
        })
    }


    useEffect(() => {
        getManualPoList();
    }, []);

    const getManualPoList = () => {
        loaderService.showLoader();
        apiClient.post(GET_MANUAL_PO_LIST,
            {
                "poStakeHolderType": "Transporter"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setManualPoList(response.data.poNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getPoDetails = (poNumber) => {
        loaderService.showLoader();
        apiClient.post(GET_PO_BY_PO_NUMBER,
            {
                "poNumber": poNumber
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPoDetails(response.data.poDetails);
                getUnrestrictedInventory(response.data.poDetails?.sourceStakeholderType, response.data.poDetails?.sourceStakeholderUrn, response.data.poDetails?.poMaterialType);
                setMonth(response.data?.poDetails?.month)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const addPlantConsumption = () => {
        loaderService.showLoader()
        let plantConsumptions = [];
        if (details?.scheduleQuantity1) {
            plantConsumptions.push({

                "schedulePickupDate": date1,
                "scheduleRbCbQuantity": details?.scheduleQuantity1

            })
        }
        if (details?.scheduleQuantity2) {
            plantConsumptions.push({
                "schedulePickupDate": date2,
                "scheduleRbCbQuantity": details?.scheduleQuantity2

            })
        }

        if (details?.scheduleQuantity3) {
            plantConsumptions.push({
                "schedulePickupDate": date3,
                "scheduleRbCbQuantity": details?.scheduleQuantity3

            })
        }

        if (details?.scheduleQuantity4) {
            plantConsumptions.push({
                "schedulePickupDate": date4,
                "scheduleRbCbQuantity": details?.scheduleQuantity4

            })
        }

        if (details?.scheduleQuantity5) {
            plantConsumptions.push({
                "schedulePickupDate": date5,
                "scheduleRbCbQuantity": details?.scheduleQuantity5

            })
        }

        if (details?.scheduleQuantity6) {
            plantConsumptions.push({
                "schedulePickupDate": date6,
                "scheduleRbCbQuantity": details?.scheduleQuantity6

            })
        }

        if (details?.scheduleQuantity7) {
            plantConsumptions.push({
                "schedulePickupDate": date7,
                "scheduleRbCbQuantity": details?.scheduleQuantity7

            })
        }

        apiClient
            .post(
                CREATE_MANUAL_SCHEDULE,
                {
                    "financialYear": poDetails?.financialYear,
                    "month": month,
                    "planningNumber": poDetails?.planningNumber,
                    "weekNumber": details?.weekNumber,
                    "expectedDeliveryDays": details?.expectedDeliveryDays,
                    "firstPartyUrn": poDetails?.sourceStakeholderUrn,
                    "firstPartyType": poDetails?.sourceStakeholderType,
                    "secondPartyUrn": poDetails?.destinationStakeholderUrn,
                    "secondPartyType": poDetails?.destinationStakeholderType,
                    "poNumber": poNumber,
                    "isManualyCreated": true,
                    "inventoryType": "",
                    "activityType": "",
                    "startDate": getStartEndDate?.weekStartDate,
                    "endDate": getStartEndDate?.weekEndDate,
                    "scheduleQuantityList": plantConsumptions
                },

                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setScheduleDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (poDetails?.financialYear && details?.weekNumber && poDetails?.month)
            getromandToDate();
    }, [poDetails?.financialYear, poDetails?.month, details?.weekNumber]);

    const onMonthChange = (e) => {
        setMonth(e.target.value);
        details?.weekNumber && getromandToDate(monthNameToNumber[e.target.value]);
    }

    const getromandToDate = (monthChangeNumber) => {
        const monthNumber = monthChangeNumber ? monthChangeNumber : monthNameToNumber[month];
        if (poDetails?.month != null && details?.weekNumber != null && poDetails?.financialYear) {
            loaderService.showLoader()
            let fiscalYear = (poDetails?.financialYear).split('-')
            apiClient
                .post(
                    GET_WEEK_START_END_DATE,
                    {
                        "year": monthNumber === 1 || monthNumber === 2 || monthNumber === 3 ? fiscalYear[1] : fiscalYear[0],
                        "month": monthNumber,
                        "weekNumber": details?.weekNumber,
                        "financialYear": poDetails?.financialYear
                    },
                    {
                        headers:
                        {
                            Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        },
                    },
                    null
                )
                .then((response) => {
                    setGetStartEndDate(response.data.weekDaysDetails);
                    response.data.weekDaysDetails?.weekStartDate === null && onClickWeekNo()
                    setGetHolidayList(response.data.plantHoldiday?.date);
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                });
        }
    };

    // const onConfirmApprove = (e) => {
    //     handleConfirmClose();
    //     addPlantConsumption();
    // }

    const onConfirmApprove = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await addPlantConsumption();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onSubmit = (e) => {
        if (!poNumber) {
            setErrorMessage({ ...errorMessage, poNumberError: "Please Select PO Number" })
        }
        // else if (!firstPartyType) {
        //     setErrorMessage({ ...errorMessage, firstPartyTypeError: "Please Select Source Stakeholder Type" })
        // }
        // else if (!firstPartyUrn) {
        //     setErrorMessage({ ...errorMessage, firstPartyUrnError: "Please Select Source Stakeholder URN" })
        // }       
        else if (!details?.weekNumber) {
            setErrorMessage({ ...errorMessage, weekNumberError: "Please Select Week Number" })
        }
        // else if (!details?.expectedDeliveryDays) {
        //     setErrorMessage({ ...errorMessage, expectedDeliveryDaysError: "Please Enter Expected Delivery days" })
        // }
        else if (process(date1) <= process(enddateFormat) && !details?.scheduleQuantity1 && !(holidate.includes(date1))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity1Error: "Please Enter Quantity" })
        }
        else if (process(date2) <= process(enddateFormat) && !details?.scheduleQuantity2 && !(holidate.includes(date2))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity2Error: "Please Enter Quantity" })
        }
        else if (process(date3) <= process(enddateFormat) && !details?.scheduleQuantity3 && !(holidate.includes(date3))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity3Error: "Please Enter Quantity" })
        }
        else if (process(date4) <= process(enddateFormat) && !details?.scheduleQuantity4 && !(holidate.includes(date4))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity4Error: "Please Enter Quantity" })
        }
        else if (process(date5) <= process(enddateFormat) && !details?.scheduleQuantity5 && !(holidate.includes(date5))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity5Error: "Please Enter Quantity" })
        }
        else if (process(date6) <= process(enddateFormat) && !details?.scheduleQuantity6 && !(holidate.includes(date6))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity6Error: "Please Enter Quantity" })
        }
        else if (process(date7) <= process(enddateFormat) && !details?.scheduleQuantity7 && !(holidate.includes(date7))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity7Error: "Please Enter Quantity" })
        }
        else {
            onSubmitButtonClick();
        }
    }
    useEffect(() => {
        if (scheduleDetails) {
            if (scheduleDetails.isSuccess === true) {
                toast.success(scheduleDetails?.message)
                navigate('/plantSchedule', { state: { planningNumber: poDetails?.planningNumber, weekNumber: details?.weekNumber, tabValue: "Transporter", month: month } })
            }
            else {
                toast.error(scheduleDetails?.message ? scheduleDetails?.message : "Error")
            }
        }
    }, [scheduleDetails]);


    const date1 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(0, 'days').format('YYYY-MM-DD')
    const date2 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(1, 'days').format('YYYY-MM-DD')
    const date3 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(2, 'days').format('YYYY-MM-DD')
    const date4 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(3, 'days').format('YYYY-MM-DD')
    const date5 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(4, 'days').format('YYYY-MM-DD')
    const date6 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(5, 'days').format('YYYY-MM-DD')
    const date7 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(6, 'days').format('YYYY-MM-DD')
    const enddateFormat = getStartEndDate?.weekEndDate && Moment(getStartEndDate?.weekEndDate).format('YYYY-MM-DD')

    const holidate = getHolidayList.map((date) => {
        return moment(moment(date)).format('YYYY-MM-DD');
    });


    const process = (date) => {
        if (date) {
            var parts = date?.split("-");
            return new Date(parts[0], parts[1] - 1, parts[2]);
        }
    }

    const onClickWeekNo = (onClose) => {
        handleLogModalOpen(onClose);
    }

    useEffect(() => {
        if (firstPartyType || stakeholderType) {
            onStakeholderTypeChange();
        }

    }, [firstPartyType, stakeholderType]);

    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
            {
                "stakeholderType": poDetails?.poStakeholderType,
                "stakeholderUrn": poDetails?.poStakeholderUrn
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (stakeholderType === "LLE") {
                    setUrnList(response.data.llleMappedPojo);
                }
                if (stakeholderType === "Interim Storage Operator") {
                    setUrnList(response.data.isMappedPojo)
                }
                if (stakeholderType === "Plant") {
                    setUrnList(response.data.plantMappedPojo);
                }
                if (firstPartyType === "LLE") {
                    setSourceUrnList(response.data.llleMappedPojo);
                }
                if (firstPartyType === "Interim Storage Operator") {
                    setSourceUrnList(response.data.isMappedPojo)
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    // useEffect(() => {
    //     const uniqueValues = Array.from(new Set(urnList?.map(item => item.stakeholderUrn)));
    //     const distinctObjects = uniqueValues?.map(value => { return urnList.find(item => item.stakeholderUrn === value); });
    //     setDistinctUrnValues(distinctObjects);
    // }, [urnList]);

    useEffect(() => {
        const uniqueValues = Array.from(new Set(sourceUrnList?.map(item => item.stakeholderUrn)));
        const distinctObjects = uniqueValues?.map(value => { return sourceUrnList.find(item => item.stakeholderUrn === value); });
        setDistinctSourceUrnValues(distinctObjects);
    }, [sourceUrnList]);

    const monthNameToNumber = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12
    };

    const monthName = poDetails?.month;
    const monthNumber = monthNameToNumber[monthName];
    const weekDayList = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

    // const onTypeChange = (e) => {
    //     setStakeholderType(e.target.value);
    //     setErrorMessage({ ...errorMessage, stakeholderTypeError: "" });
    //     setStakeholderUrn("");
    //     setUrnList([]);
    // }

    // const onUrnChange = (e) => {
    //     setStakeholderUrn(e.target.value);
    //     setErrorMessage({ ...errorMessage, stakeholderUrnError: "" });
    // }

    const onSourceTypeChange = (e) => {
        setFirstPartyType(e.target.value);
        setErrorMessage({ ...errorMessage, firstPartyTypeError: "" });
        setFirstPartyUrn("");
        setSourceUrnList([]);
    }

    const onSourceUrnChange = (e) => {
        setFirstPartyUrn(e.target.value);
        setErrorMessage({ ...errorMessage, firstPartyUrnError: "" });
    }

    const getUnrestrictedInventory = (sourceType, sourceUrn, materialType) => {
        loaderService.showLoader();
        apiClient.post(GET_INVENTORY_AVAILABLE_FOR_SCHEDULING,
            {
                "stakeHolderUrn": sourceUrn,
                "stakeHolderType": sourceType,
                "materialType": materialType === "chipbamboo" ? "CB" : materialType === "rawbamboo" ? "RB" : ''
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setInventoryLevel(response.data);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT20</p>}
                <Typography variant="h5" gutterBottom>
                    Transporter Schedule Creation
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poNumberError}>
                                            <InputLabel>Manual PO Number</InputLabel>
                                            <Select label="Manual PO Number" name="poNumber" onChange={(e) => onPoNumberChange(e)}>
                                                {manualPoList &&
                                                    manualPoList.map((items) => (
                                                        <MenuItem value={items}>{items}</MenuItem>
                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poNumberError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder Type'
                                            name="stakeholderType"
                                            value={poDetails?.poStakeholderType || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder URN'
                                            name="stakeholderUrn"
                                            value={poDetails?.poStakeholderUrn || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Stakeholder Name'
                                            value={poDetails?.poStakeholderName || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Financial Year'
                                            name="financialYear"
                                            value={poDetails?.financialYear || ''}
                                            disabled
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Month'
                                            name="month"
                                            value={poDetails?.month || ''}
                                            disabled
                                        />
                                    </Grid> */}

                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                                            <InputLabel>Month</InputLabel>
                                            <Select required label="Month" value={month || ''} name="month" onChange={(e) => onMonthChange(e)}>
                                                {/* <MenuItem><em>Month</em></MenuItem> */}
                                                <MenuItem value="Jan" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jan"]}>January</MenuItem>
                                                <MenuItem value="Feb" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Feb"]}>February</MenuItem>
                                                <MenuItem value="Mar" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Mar"]}>March</MenuItem>
                                                <MenuItem value="Apr" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Apr"]}>April</MenuItem>
                                                <MenuItem value="May" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["May"]}>May</MenuItem>
                                                <MenuItem value="Jun" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jun"]}>June</MenuItem>
                                                <MenuItem value="Jul" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Jul"]}>July</MenuItem>
                                                <MenuItem value="Aug" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Aug"]}>August</MenuItem>
                                                <MenuItem value="Sep" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Sep"]}>September</MenuItem>
                                                <MenuItem value="Oct" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Oct"]}>October</MenuItem>
                                                <MenuItem value="Nov" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Nov"]}>November</MenuItem>
                                                <MenuItem value="Dec" disabled={monthNameToNumber[poDetails?.month] > monthNameToNumber["Dec"]}>December</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required={errorMessage.firstPartyTypeError}>
                                            <InputLabel>Source Stakeholder Type</InputLabel>
                                            <Select label="Source Stakeholder Type" name="firstPartyType" value={firstPartyType || ''} onChange={(e) => onSourceTypeChange(e)}>
                                                <MenuItem value="LLE">LLE</MenuItem>
                                                <MenuItem value="InterimStorageOperator">IS</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.firstPartyTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.firstPartyUrnError}>
                                            <InputLabel>Source Stakeholder URN</InputLabel>
                                            <Select label="Source Stakeholder URN" value={firstPartyUrn || ''} name="firstPartyUrn" onChange={(e) => onSourceUrnChange(e)}>
                                                {distinctSourceUrnValues &&
                                                    distinctSourceUrnValues?.map((items) => (
                                                        <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>

                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.firstPartyUrnError}</FormHelperText>
                                        </FormControl>
                                    </Grid> */}
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder Type" value={poDetails?.destinationStakeholderType || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder URN" value={poDetails?.destinationStakeholderUrn || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Destination Stakeholder Name" value={poDetails?.destinationStakeholderName || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Source Stakeholder Type" value={poDetails?.sourceStakeholderType || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Source Stakeholder URN" value={poDetails?.sourceStakeholderUrn || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Source Stakeholder Name" value={poDetails?.sourceStakeholderName || ''} disabled />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Inventory level'
                                            name="inventoryLevel"
                                            value={inventoryLevel || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Balance Quantity (MT)'
                                            name="poBalanceQuantity (MT)"
                                            value={poDetails?.poBalanceQuantity || ''}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.weekNumberError}>
                                            <InputLabel>Week Number</InputLabel>
                                            <Select label="Week Number" name="weekNumber" value={details?.weekNumber} onChange={(e) => handleChange(e)}>
                                                <MenuItem value="select" selected>Week Number</MenuItem>
                                                <MenuItem value="1">1</MenuItem>
                                                <MenuItem value="2">2</MenuItem>
                                                <MenuItem value="3">3</MenuItem>
                                                <MenuItem value="4">4</MenuItem>
                                                <MenuItem value="5">5</MenuItem>
                                                <MenuItem value="6">6</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.weekNumberError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Schedule From"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="date"
                                                    value={getStartEndDate?.weekStartDate}
                                                    disabled
                                                    renderInput={(params) => <TextField size="small" {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Schedule To"
                                                    inputFormat="DD/MM/YYYY"
                                                    name="pickUpToDate"
                                                    value={getStartEndDate?.weekEndDate}
                                                    disabled
                                                    renderInput={(params) => <TextField size="small" {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            required
                                            error={errorMessage.expectedDeliveryDaysError}
                                            helperText={errorMessage.expectedDeliveryDaysError}
                                            label="Expected Delivery Days"
                                            type="number"
                                            name="expectedDeliveryDays"
                                            value={details.expectedDeliveryDays}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </Grid> */}

                                </Grid>
                            </Grid>
                            <Divider sx={{
                                width: '105%',
                                bgcolor: 'black',
                                marginTop: '3vh'
                            }} mt={2} />
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <>
                                        {getStartEndDate?.weekStartDate &&
                                            <>
                                                <Grid item xs={12} lg={12}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Schedule Quantity
                                                    </Typography>
                                                </Grid>
                                                {process(date1) <= process(enddateFormat) && !(holidate.includes(date1)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity1Error}
                                                            helperText={errorMessage.scheduleQuantity1Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity1"
                                                            value={details.scheduleQuantity1}
                                                            label={weekDayList[new Date(date1).getDay()] + ' ' + (date1 && Moment(date1).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date2) <= process(enddateFormat) && !(holidate.includes(date2)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity2Error}
                                                            helperText={errorMessage.scheduleQuantity2Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity2"
                                                            value={details.scheduleQuantity2}
                                                            label={weekDayList[new Date(date2).getDay()] + ' ' + (date2 && Moment(date2).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date3) <= process(enddateFormat) && !(holidate.includes(date3)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity3Error}
                                                            helperText={errorMessage.scheduleQuantity3Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity3"
                                                            value={details.scheduleQuantity3}
                                                            label={weekDayList[new Date(date3).getDay()] + ' ' + (date3 && Moment(date3).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date4) <= process(enddateFormat) && !(holidate.includes(date4)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity4Error}
                                                            helperText={errorMessage.scheduleQuantity4Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity4"
                                                            value={details.scheduleQuantity4}
                                                            label={weekDayList[new Date(date4).getDay()] + ' ' + (date4 && Moment(date4).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date5) <= process(enddateFormat) && !(holidate.includes(date5)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity5Error}
                                                            helperText={errorMessage.scheduleQuantity5Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity5"
                                                            value={details.scheduleQuantity5}
                                                            label={weekDayList[new Date(date5).getDay()] + ' ' + (date5 && Moment(date5).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date6) <= process(enddateFormat) && !(holidate.includes(date6)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity6Error}
                                                            helperText={errorMessage.scheduleQuantity6Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity6"
                                                            value={details.scheduleQuantity6}
                                                            label={weekDayList[new Date(date6).getDay()] + ' ' + (date6 && Moment(date6).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />
                                                    </Grid>
                                                    : null
                                                }
                                                {process(date7) <= process(enddateFormat) && !(holidate.includes(date7)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity7Error}
                                                            helperText={errorMessage.scheduleQuantity7Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity7"
                                                            value={details.scheduleQuantity7}
                                                            label={weekDayList[new Date(date7).getDay()] + ' ' + (date7 && Moment(date7).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />

                                                    </Grid>
                                                    : null
                                                }

                                            </>
                                        }

                                    </>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100 }} variant="contained" type='submit' onClick={(e) => onSubmit(e)}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Submit" />
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <PlantConsumptionPopover handleLogModalClose={handleLogModalClose} />
                </DialogContent>
            </Dialog>

        </>
    )
}
export default TransporterScheduleCreation;